import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-075bcfe7")

_pushScopeId("data-v-075bcfe7")
const _hoisted_1 = {
  class: "modal fade",
  id: "modalDocumento",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-xl",
  style: {"height":"70vh"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "staticBackdropLabel"
  }, "Documento")
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }
const _hoisted_7 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Cerrar", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("iframe", {
            src: _ctx.rutaDocumento,
            width: "100%",
            style: {"height":"50vh"}
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DescargaPDF())),
            type: "button",
            class: "btn btn-warning",
            "data-bs-dismiss": "modal"
          }, " Descargar "),
          _hoisted_7
        ])
      ])
    ])
  ]))
})